// @flow
import { getLang } from '../../../i18n/l10n';
import type { UserType } from '../../../store/types';
import type { PaypalUserData } from '../types';

export const paypalDataToUserTypeAdapter = (data: PaypalUserData): UserType => {
  const state = `${data.address?.region?.[0]?.toUpperCase()}${data.address?.region
    ?.slice(1)
    .toLowerCase()}}`;
  const country = data.address?.country
    ? new Intl.DisplayNames([getLang()], { type: 'region' }).of(data.address.country)
    : null;
  return {
    first_name: data.given_name,
    last_name: data.family_name,
    address1: data.address?.street_address,
    zip_code: data.address?.postal_code,
    city: data.address?.locality,
    country,
    country_code: data.address?.country,
    state,
    email: data.email,
  };
};
